import { render, staticRenderFns } from "./ListadoControlDeAccesos.vue?vue&type=template&id=4fcd3d96"
import script from "./ListadoControlDeAccesos.vue?vue&type=script&lang=js"
export * from "./ListadoControlDeAccesos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports